import watcherApi from '../api/watcherApi';
import { createAsyncThunk } from "@reduxjs/toolkit";

type loginParams = {
  username: string;
  password: string;
}

export const signIn = createAsyncThunk(
  'sessions/login',
  async (credentials: loginParams, { rejectWithValue }) => {
    try {
      const response = await watcherApi.post('/onesky/login', credentials);
      return response.data.admin;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.errors || error);
    }
  }
);

export const launchApp = createAsyncThunk(
  'sessions/launchApp',
  async () => {
    const response = await watcherApi.post('/onesky/launch');
    return response.data.admin;
  }
);
